<script lang="ts" setup>
import { useLocale } from "vuetify";

const { current, t } = useLocale();
</script>

<template>
  <footer class="text-white bg-severus-blue overflow-auto lang-en">
    <img
      alt="LH Severus logo"
      class="
        mt-10 mb-5 px-16 w-full
        sm:mx-auto sm:max-w-sm"
      src="/images/lh-severus-logo-white.svg">

      <div class="border-severus-white"></div>

    <div
      class="
        max-lg:[&>:not(:first-child)]:border-t
        sm:mx-[15%] pt-8 pb-20 text-sm
        lg:mx-auto lg:flex items-stretch justify-center"
      :class='current === "ar"
        ? "lg:[&>:not(:first-child)]:border-r"
        : "lg:[&>:not(:first-child)]:border-l"'>
      <div class="text-center mx-auto py-10 px-2">
        <span class="inline-flex items-center text-lg">
          <span class="pl-[8px] pr-[8px] sm:pl-[24px] sm:pr-[24px]">{{ t("siteFooter.cities.malta") }}</span>
          <span>|</span>
          <span class="pl-[8px] pr-[8px] sm:pl-[24px] sm:pr-[24px]">{{ t("siteFooter.cities.benghazi") }}</span>
          <span>|</span>
          <span class="pl-[8px] pr-[8px] sm:pl-[24px] sm:pr-[24px]">{{ t("siteFooter.cities.tripoli") }}</span>
          <span>|</span>
          <span class="pl-[8px] pr-[8px] sm:pl-[24px] sm:pr-[24px]">{{ t("siteFooter.cities.dubai") }}</span>
        </span>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.address { @apply px-4 py-10 lg:px-16 lg:py-4 not-italic border-white/70; }
</style>
